export default __webpack_public_path__ + "static/media/chuvaFraca.022ccf47.svg";